import React from 'react'
import PropTypes from 'prop-types'

import { t } from 'src/lib/i18n-react'
import PageWrapupCelebration from 'src/ui/PageWrapup/subcomponents/PageWrapupCelebration/PageWrapupCelebration'

import {
  GOAL_REACHED_WEEKLY,
  GOAL_REACHED_NONE,
} from '../../utils/celebrations'

import animationCarBear from './assets/01-car-bear.svg'
import animationDancingBear from './assets/02-dancing-bear.svg'
import animationFishingBear from './assets/03-fishing-bear.svg'
import animationUFO from './assets/04-ufo.svg'
import animationFootballBear from './assets/05-football-bear.svg'
import animationGolfBear from './assets/06-golf-bear.svg'
import animationMotorbikeBear from './assets/07-motorbike-bear.svg'
import animationMagicUnicorn from './assets/08-magic-unicorn.svg'
import animationMagicMusic from './assets/09-music-unicorn.svg'
import animationSkateLlama from './assets/10-skate-llama.svg'
import animationSuperBear from './assets/11-super-bear.svg'
import animationSurfBear from './assets/12-surf-bear.svg'

export const ASSETS = [
  {
    title: t("You're Cruising!"),
    animation: animationCarBear,
  },
  {
    title: t("You're rockin' it!"),
    animation: animationDancingBear,
  },
  {
    title: t('Good Catch!'),
    animation: animationFishingBear,
  },
  {
    title: t('Awesome Skills!'),
    animation: animationFootballBear,
  },
  {
    title: t('Excellent Shot!'),
    animation: animationGolfBear,
  },
  {
    title: t('Full speed ahead!'),
    animation: animationMotorbikeBear,
  },
  {
    title: t("Surf's Up!"),
    animation: animationSurfBear,
  },
  {
    title: t('Out of this World!'),
    animation: animationUFO,
  },
  {
    title: t('Pure Magic!'),
    animation: animationMagicUnicorn,
  },
  {
    title: t('Sweet Music!'),
    animation: animationMagicMusic,
  },
  {
    title: t('Rock On!'),
    animation: animationSkateLlama,
  },
  {
    title: t('Superb!'),
    animation: animationSuperBear,
  },
]

const getRandomAsset = (assets) => {
  const max = assets.length
  const index = Math.floor(Math.random() * max)

  return assets[index] || assets[0]
}

const WrapupGoalCelebration = ({ goalReached }) => {
  if (!goalReached || goalReached === GOAL_REACHED_NONE) {
    return null
  }

  const asset = getRandomAsset(ASSETS)
  let subtitle = ''

  switch (goalReached) {
    case GOAL_REACHED_WEEKLY:
      subtitle = t('You’ve reached your Weekly goal!')
      break
    default:
      break
  }

  return (
    <PageWrapupCelebration
      title={asset.title}
      subtitle={subtitle}
      image={{
        url: asset.animation,
        width: 168,
        height: 168,
      }}
    />
  )
}

WrapupGoalCelebration.propTypes = {
  goalReached: PropTypes.oneOf([
    GOAL_REACHED_WEEKLY,
    GOAL_REACHED_NONE,
  ]).isRequired,
}

export default WrapupGoalCelebration
